type Props = {
  color?: string;
};

const NoDataSvg = ({ color = '#584cd2' }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' fill='none' viewBox='0 0 80 80'>
      <path fill='#FD853A' d='m40 31.667-26.666-8.334L40.001 15l26.666 8.333z' opacity='0.9'></path>
      <path
        fill='#FB6514'
        d='M40 65V31.666l26.667-8.333v33.333zM40 65V31.666l-26.666-8.333v33.333z'
      ></path>
      <path
        fill='#FB6514'
        d='m66.667 23.333-26.666 8.333L45 40l26.666-8.334zm-53.333 0 26.667 8.333L35 40 8.334 31.666z'
      ></path>
      <path
        fill='#FFFDFD'
        fillRule='evenodd'
        d='M14.629 26.677a.834.834 0 0 1 .232 1.155l-1.054 1.581 19.78 6.33a.832.832 0 1 1-.506 1.587l-20.834-6.666a.834.834 0 0 1-.44-1.256l1.667-2.5a.833.833 0 0 1 1.155-.233zm1.31 7.282a.834.834 0 0 1 .833.833v20a.833.833 0 0 1-1.666 0v-20a.833.833 0 0 1 .833-.834'
        clipRule='evenodd'
      ></path>
      <path
        fill='#1F0202'
        fillRule='evenodd'
        d='M40.25 32.462a.83.83 0 0 1-.5 0l-26.666-8.333a.834.834 0 0 1 0-1.59l26.666-8.334a.83.83 0 0 1 .5 0l26.667 8.334a.834.834 0 0 1 0 1.59zm23.622-9.128L40 15.874l-23.873 7.46L40 30.794z'
        clipRule='evenodd'
      ></path>
      <path
        fill='#1F0202'
        fillRule='evenodd'
        d='M40 30.833a.833.833 0 0 0-.834.833V65a.834.834 0 0 0 1.083.795l26.667-8.334a.83.83 0 0 0 .583-.795V33.333a.833.833 0 1 0-1.666 0v22.72l-25 7.813v-32.2a.833.833 0 0 0-.834-.833'
        clipRule='evenodd'
      ></path>
      <path
        fill='#1F0202'
        fillRule='evenodd'
        d='M40 30.833a.833.833 0 0 1 .833.833V65a.834.834 0 0 1-1.083.795L13.083 57.46a.83.83 0 0 1-.583-.795V33.333a.833.833 0 1 1 1.667 0v22.72l25 7.813v-32.2a.834.834 0 0 1 .833-.833'
        clipRule='evenodd'
      ></path>
      <path
        fill='#1F0202'
        fillRule='evenodd'
        d='M66.238 22.619a.834.834 0 0 0-.287 1.143l4.455 7.425-25.03 7.821-4.661-7.77a.832.832 0 0 0-1.54.551.8.8 0 0 0 .11.306l5 8.334a.83.83 0 0 0 .963.366l26.667-8.333a.835.835 0 0 0 .466-1.224l-5-8.333a.834.834 0 0 0-1.143-.287'
        clipRule='evenodd'
      ></path>
      <path
        fill='#1F0202'
        fillRule='evenodd'
        d='M13.762 22.619a.834.834 0 0 1 .286 1.143l-4.455 7.425 25.03 7.821 4.662-7.77a.834.834 0 0 1 1.43.857l-5 8.334a.83.83 0 0 1-.963.366L8.085 32.462a.834.834 0 0 1-.467-1.224l5-8.333a.834.834 0 0 1 1.144-.287'
        clipRule='evenodd'
      ></path>
    </svg>
  );
};

export default NoDataSvg;
